import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.purchaseOrder || initialState;

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);
